import { useMutation, useQueryClient } from '@tanstack/react-query'

import {
  updateBookingProducts,
  type UpdateBookingProductsOptions,
} from '@flecto/api/saas'
import { type CoreBookingProductPayload, type ParameterID } from '@flecto/types'

type MutationPayload = {
  bookingId?: ParameterID
  body: CoreBookingProductPayload[]
  options?: UpdateBookingProductsOptions
}

export function useMutationUpdateBookingProducts() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationKey: ['MutationUpdateBookingProducts'],
    mutationFn: async ({ bookingId, body, options }: MutationPayload) => {
      await updateBookingProducts(bookingId ?? '', body, options)

      queryClient.invalidateQueries({
        queryKey: ['QueryGetAllProductsAvailability'],
        refetchType: 'all',
      })

      queryClient.invalidateQueries([
        'QueryGetAllBookingProducts',
        Number(bookingId),
      ])

      queryClient.resetQueries([
        'QueryGetAllBookingProductsUnavailable',
        Number(bookingId),
      ])

      queryClient.resetQueries([
        'QueryGetAllBookingProductsSelection',
        Number(bookingId),
      ])

      queryClient.invalidateQueries(['QueryGetAllItemCategoriesV2'])

      queryClient.invalidateQueries(['QueryGetBookingById', Number(bookingId)])
    },
  })
}
